import { useMemo } from 'react';

import { tankMixesConfigService } from '../../../../services/tankMixesConfig.service';
import { createApiSlice } from '../../utils/createApiSlice';

const createTankMixProductSlice = createApiSlice({
  reducerPath: ['newConfig', 'tankMixes', 'createProduct'],
  apiFunction: tankMixesConfigService.createTankMixProductV2,
  apiArgumentsFn: ({ product }) => [product]
});

const { actions, useApiSelectors } = createTankMixProductSlice;

export const createTankMixProductActions = actions;

export const useCreateTankMixProductSelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default createTankMixProductSlice;
